(function() {
	/******************
		* This is a helper method to escape regex strings.
		* It should be used on form elements when you are doing a match password input pattern
		* Usage Examples:
				input(
					required
					type='text', 
					name="mustMatchMe",  
					pattern='[0-9]{9}',
					title="Must be 9 numeric characters long.", required,
	 (1)-->	oninput="form.makeMatch.pattern = blue.meth.escapeRegex(this.value)")

				input(
					required
					type='text', 
	 (2)-->	name="makeMatch", 
					pattern='', 
					title="Routing numbers must match.")
	******************/
	const escapeRegex = blue.meth.escapeRegex = (str) => {
		return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	}
})();